import React from 'react';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { Navigate } from 'react-router-dom';
import { loginRequest } from '../auth/msalConfig';
import { Box, Button, Typography, Paper } from '@mui/material';

export default function Login() {
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  // Already signed in — send straight to the app
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  const handleLogin = () => {
    // redirectStartPage ensures MSAL navigates to '/' after Azure AD callback,
    // not back to '/login' where the redirect was initiated
    instance.loginRedirect({ ...loginRequest, redirectStartPage: '/' });
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        bgcolor: 'background.default',
      }}
    >
      <Paper elevation={3} sx={{ p: 6, textAlign: 'center', maxWidth: 360 }}>
        <Typography variant="h5" gutterBottom fontWeight={600}>
          PMS Image Governance
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={4}>
          Sign in with your Microsoft account to continue.
        </Typography>
        <Button
          variant="contained"
          size="large"
          fullWidth
          onClick={handleLogin}
          startIcon={
            <img
              src="https://learn.microsoft.com/en-us/azure/active-directory/develop/media/howto-add-branding-in-apps/ms-symbollockup_mssymbol_19.svg"
              alt=""
              width={18}
              height={18}
            />
          }
        >
          Sign in with Microsoft
        </Button>
      </Paper>
    </Box>
  );
}
